import { isProError } from 'shared/api/common/errors/proError'

export const groupsApiGuard = {
  switchAutoAssign: {
    isProError,
  },
}
